import styled from 'styled-components';
import { NoResult } from 'ui/illustrations';
import { EmptyState } from 'ui/emptyState';
import { colors, spacing } from 'ui/theme';

const Wrapper = styled.div`
  background: ${colors.backgroundSecondary};
  padding: ${spacing.x4} ${spacing.x5} ${spacing.x4} ${spacing.x5};
`;

export const NoResultsEmptyState = () => (
  <Wrapper>
    <EmptyState
      title="No matching results"
      subtitle="Try adjusting your filters or searching by different keywords."
      Illustration={NoResult}
    />
  </Wrapper>
);
